import * as tslib_1 from "tslib";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Doughnut } from 'vue-chartjs';
const dbBackground = 'rgba(32, 36, 39, 1)';
const dbTitle = 'rgba(255, 255, 255, 1)';
const dbGrey = 'rgba(255, 255, 255, 1)';
const dbGreen = 'rgba(0, 241, 155, 1)';
const dbOrange = 'rgba(255, 169, 0, 1)';
const dbRed = 'rgba(239, 83, 80, 1)';
let chart = class chart extends Vue {
    watchdbs() { this.updateData(); }
    watchhigh() { this.updateData(); }
    watchsafe() { this.updateData(); }
    watchunsafe() { this.updateData(); }
    get chartData() {
        return {
            labels: [this.$t('widgets.dbDoughnut.safe'), this.$t('widgets.dbDoughnut.high'), this.$t('widgets.dbDoughnut.unsafe')],
            datasets: [{
                    label: 'Data One',
                    borderColor: dbBackground,
                    borderWidth: 8,
                    backgroundColor: [dbGreen, dbOrange, dbRed],
                    data: [Math.round(this.safe), Math.round(this.high), Math.round(this.unsafe)]
                }]
        };
    }
    get options() {
        return {
            maintainAspectRatio: false,
            tooltips: {
                callbacks: {
                    label: (tooltipItem, data) => {
                        const label = data.labels[tooltipItem.index];
                        const v = data.datasets[0].data[tooltipItem.index];
                        return `${label}: ${v}%`;
                    }
                }
            },
            responsive: true,
            title: {
                display: true,
                text: this.$t('widgets.dbDoughnut.title'),
                fontColor: dbTitle,
                fontFamily: 'Lato',
                fontSize: 16
            },
            color: '#fff',
            // rotation: 0.6,
            legend: {
                display: false,
            },
            elements: {
                arc: {
                    borderWidth: 22,
                },
                center: {
                    db: Math.round(this.dbs),
                    color: dbGrey,
                    fontStyle: 'Lato',
                    sidePadding: 50 //Default 20 (as a percentage)
                }
            },
            cutoutPercentage: 78
        };
    }
    updateData() {
        let chart = this.$data._chart;
        if (chart) {
            chart.destroy();
            this.$emit('chart:destroy');
        }
        const that = this;
        that.renderChart(this.chartData, this.options);
        this.$emit('chart:render');
    }
    mounted() {
        this.$data._plugins.push({
            id: 'dbs-inner-text',
            beforeDraw(chart) {
                if (chart.config.options.elements.center) {
                    var ctx = chart.chart.ctx;
                    var centerConfig = chart.config.options.elements.center;
                    if (!centerConfig.db)
                        return;
                    var fontStyle = centerConfig.fontStyle || 'Lato';
                    var txt = centerConfig.db;
                    var color = centerConfig.color || '#fff';
                    var sidePadding = centerConfig.sidePadding || 20;
                    var sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2);
                    //Start with a base font of 30px
                    ctx.font = "30px " + fontStyle;
                    //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
                    var stringWidth = ctx.measureText(txt).width;
                    var elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;
                    // Find out how much the font can grow in width.
                    var widthRatio = elementWidth / stringWidth;
                    var newFontSize = Math.floor(30 * widthRatio);
                    var elementHeight = (chart.innerRadius * 2);
                    // Pick a new font size so it will not be larger than the height of label.
                    var fontSizeToUse = Math.min(newFontSize, elementHeight);
                    //Set font settings to draw it correctly.
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
                    var centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2 - elementHeight / 20 * 0.8);
                    var centerYDb = ((chart.chartArea.top + chart.chartArea.bottom) / 2 + elementHeight / 20 * 4.5);
                    ctx.font = fontSizeToUse + "px " + fontStyle;
                    ctx.fillStyle = color;
                    //Draw text in center
                    ctx.fillText(txt, centerX, centerY);
                    ctx.font = newFontSize / 2.5 + "px " + fontStyle;
                    ctx.fillText('dB', centerX, centerYDb);
                }
            }
        });
        this.renderChart(this.chartData, this.options);
    }
};
tslib_1.__decorate([
    Prop({ required: true })
], chart.prototype, "dbs", void 0);
tslib_1.__decorate([
    Prop({ required: true })
], chart.prototype, "high", void 0);
tslib_1.__decorate([
    Prop({ required: true })
], chart.prototype, "safe", void 0);
tslib_1.__decorate([
    Prop({ required: true })
], chart.prototype, "unsafe", void 0);
tslib_1.__decorate([
    Watch('dbs')
], chart.prototype, "watchdbs", null);
tslib_1.__decorate([
    Watch('high')
], chart.prototype, "watchhigh", null);
tslib_1.__decorate([
    Watch('safe')
], chart.prototype, "watchsafe", null);
tslib_1.__decorate([
    Watch('unsafe')
], chart.prototype, "watchunsafe", null);
chart = tslib_1.__decorate([
    Component({ extends: Doughnut })
], chart);
export default chart;
